module.exports = __webpack_public_path__ + "img/logo.a06cdc2d.png";